"use strict";
import { LDO, MNW, NMR, USDT as USDT_MAINNET } from "constants/tokens";
export const RESET_APPROVAL_TOKENS = [USDT_MAINNET, LDO, NMR, MNW];
export var Field = /* @__PURE__ */ ((Field2) => {
  Field2["INPUT"] = "INPUT";
  Field2["OUTPUT"] = "OUTPUT";
  return Field2;
})(Field || {});
